import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import Moment from 'react-moment';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class userBillingInvoices extends Component {

    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            isLoading: true,
            search: "",
            per_page: 10,
            page: 0,
            isLoadingButton: false,
            show_loadmore: true
        };
    };

    componentWillMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/billing/receipts');
            ReactGA4.send({ hitType: "pageview", page: "/user/billing/receipts" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        this._updateItems();
    }

    _updateItems(){
        dataRegister.getInvoices(salesChannelRegister.get('market'), langRegister.lang(), this.state.page, this.state.per_page).then((response) => {
            if(response.constructor === Array){
                this.setState({campaigns: response, isLoading: false, error: false, page: this.state.page + 1}, () => {
                    if(response.length < 10){
                        this.setState({show_loadmore: false});
                    }
                });
            }else{
                this.setState({isLoading: false});
            }
        }, (error) => {
            if(error.status === 401){
                userRegister.remove();
                tokenRegister.remove();
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            }else{
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _loadMore(){
        this.setState({isLoadingButton: true}, () => {
            dataRegister.getInvoices(salesChannelRegister.get('market'), langRegister.lang(), this.state.page, this.state.per_page).then((response) => {
                if(response.constructor === Array){
                    if(response.length > 0){
                        let campaigns = this.state.campaigns.concat(response);
                        this.setState({campaigns: campaigns, isLoadingButton: false, error: false, page: this.state.page + 1}, () => {
                            if(response.length < 10){
                                this.setState({show_loadmore: false});
                            }
                        });
                    }else{
                        this.setState({isLoadingButton: false, error: false, show_loadmore: false});
                    }
                }else{
                    this.setState({isLoadingButton: false});
                }
            }, (error) => {
                if(error.status === 401){
                    userRegister.remove();
                    tokenRegister.remove();
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                }else{
                    this.setState({isLoading: false, error: true});
                }
            });
        });
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
    }

    _selectInvoice(hash){
        window.open("https://invoice."+dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + hash, '_blank');
    }

    _renderText(item) {
        return langRegister.get("user-billing-receipts", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>
                        <input value={this.state.search} onChange={(event) => this.setState({search: event.target.value})} placeholder={this._renderText("item_3")} className={Styles.contentHeaderSearchInput}/>
                        <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon.png")}/>
                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    <div className={Styles.containerInner}>
                        {
                            !this.state.isLoading && this.state.campaigns.length > 0 && !this.state.error &&
                            this.state.campaigns.filter((item) => {return item.industry.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.campaign_id).indexOf(this.state.search.toLowerCase()) !== -1}).sort((a, b) => b.id - a.id).map((item) => {
                                return(
                                    <div className={Styles.contentInnerItem}>
                                        <div className={Styles.contentInnerItemHeader}>
                                            <div className={Styles.contentInnerItemHeaderTitle}>
                                                <Moment format="YYYY.MM.DD">
                                                    {item.created.date}
                                                </Moment>
                                            </div>
                                            <div className={Styles.contentInnerItemHeaderIndustry}>
                                                {item.industry}&nbsp;
                                            </div>
                                            <div className={Styles.contentInnerItemHeaderId}>#{item.campaign_id}</div>
                                            <div className={Styles.cardStatusContainer}>
                                                <div className={
                                                    cx(Styles.cardStatus,
                                                        {
                                                            [Styles.cardStatusPending]: (item.status === "FAILED" || item.status === "AWAITING_PAYMENT" || item.status === "3D_PAYMENT"),
                                                            [Styles.cardStatusProcessing]: !item.status
                                                        })
                                                }>
                                                    <div className={
                                                        cx(Styles.cardStatusDot,
                                                            {
                                                                [Styles.cardStatusPending]: (item.status === "FAILED" || item.status === "AWAITING_PAYMENT" || item.status === "3D_PAYMENT"),
                                                                [Styles.cardStatusProcessing]: !item.status
                                                            })
                                                    }>
                                                        &#9679;
                                                    </div>
                                                    <div className={
                                                        cx(Styles.cardStatusTitle,
                                                            {
                                                                [Styles.cardStatusPending]: (item.status === "FAILED" || item.status === "AWAITING_PAYMENT" || item.status === "3D_PAYMENT"),
                                                                [Styles.cardStatusProcessing]: !item.status
                                                            })
                                                    }>
                                                        {
                                                            item.status === "PAID" &&
                                                            <span>{this._renderText("item_4")}</span>
                                                        }
                                                        {
                                                            !item.status &&
                                                            <span>{this._renderText("item_5")}</span>
                                                        }
                                                        {
                                                            (item.status === "FAILED" || item.status === "AWAITING_PAYMENT" || item.status === "3D_PAYMENT") &&
                                                            <span>{this._renderText("item_6")}</span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div onClick={() => this._selectInvoice(item.hash)} className={Styles.contentInnerItemHeaderEdit}>
                                                {this._renderText("item_2")}
                                            </div>
                                            <div onClick={() => this._selectInvoice(item.hash)} className={Styles.contentInnerItemHeaderEditMobile}>
                                                <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/download_icon.png")}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {
                            !this.state.isLoading && !this.state.error && this.state.show_loadmore &&
                            <div className={Styles.loadMoreButtonContainer}>
                                <div className={Styles.loadMoreButton} onClick={() => {this._loadMore()}}>
                                    {
                                        this.state.isLoadingButton &&
                                        <BeatLoader size={10} color={'#ffffff'} loading={true}/>
                                    }
                                    {
                                        !this.state.isLoadingButton &&
                                        <img className={Styles.loadMoreButtonIcon} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    {
                        !this.state.isLoading && this.state.campaigns.length < 1 && !this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_7")}
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_8")}
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default userBillingInvoices;


// WEBPACK FOOTER //
// ./src/components/user-billing-invoices/component.js